import { PartTypeSchema, PartTypeType } from "../types";

export const getSkeletonLoss = (partType: PartTypeType, skeletonWidth: number): number => {
  switch (partType) {
    case PartTypeSchema.enum.SHEET:
    case PartTypeSchema.enum.MACHINING:
      return getSkeletonLossForSheetOrMachining(skeletonWidth);
    case PartTypeSchema.enum.ROUND_BAR:
    case PartTypeSchema.enum.SQUARE_BAR:
    case PartTypeSchema.enum.RECTANGULAR_TUBE:
    case PartTypeSchema.enum.ROUND_TUBE:
    case PartTypeSchema.enum.SQUARE_TUBE:
    case PartTypeSchema.enum.PROFILE:
      return getSkeletonLossForBarOrProfile(skeletonWidth);
    case PartTypeSchema.enum.ASSEMBLY:
    case PartTypeSchema.enum.OTHER:
    case PartTypeSchema.enum.CONSUMABLE:
      return 0;
  }
};

export const getSkeletonLossForSheetOrMachining = (skeletonWidth: number) => {
  return skeletonWidth * 2;
};

export const getSkeletonLossForBarOrProfile = (skeletonWidth: number) => {
  return skeletonWidth;
};
